import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CommentPage } from './comment';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    CommentPage,
  ],
  imports: [
  	TranslateModule,
    IonicPageModule.forChild(CommentPage),
  ],
})
export class CommentPageModule {}



// WEBPACK FOOTER //
// ./src/pages/comment/comment.module.ts